<template>
  <div :class="classnames">
    <open-modal-control
      :view="'modal-view-share'"
      :props="shareData"
    >
      <vue-button direction="rtl">
        <template slot="text">Share</template>
        <template slot="icon">
          <SvgIconShare />
        </template>
      </vue-button>
    </open-modal-control>
  </div>
</template>

<script>
import OpenModalControl from '@/components/OpenModalControl'
import VueButton from '@/components/VueButton'

import SvgIconSend from '@/svgs/SvgIconSend'
import SvgIconShare from '@/svgs/SvgIconShare'

import { bem } from '@/mixins/bem.js'

const namespace = 'toolbar-share-button'

export default {
  name: 'ToolbarShareButton',
  components: {
    'open-modal-control': OpenModalControl,
    'svg-icon-send': SvgIconSend,
    'vue-button': VueButton,
    SvgIconShare
  },
  mixins: [bem],
  props: {
    shareData: {
      type: Object
    }
  },
  data: function () {
    return {}
  },
  created: function () {
    this.namespace = namespace
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/ToolbarShareButton.vue